import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import clsx from 'clsx';

import { useSelector } from 'react-redux';
import { FormInput } from '../../../../../components/index';
import { Article } from '../../../../../types/items';
import { FileIcon } from '../../../../../components/icon/solid';
import { MediaStyles } from './styles';
import { DeleteAction, DownloadDocumentAction, LockAction } from './actions/index';
import UploadProgress from './UploadProgress';
import { selectArticlesMediaSubmitState } from '../../../../../store/modules/articles/selectors';
import AdvancedActionCell from '../../../../../components/action-cell/AdvancedActionCell';
import MediaItemImage from './MediaItemImage';
import { useField } from 'formik';


type Props = {
  media: Article;
  openMediaPreview: () => void;
  keyUpHandler?: (e: React.KeyboardEvent) => void;
};

const MediaPaged = ({ media, openMediaPreview, keyUpHandler = () => {} }: Props) => {
  const classes = MediaStyles();
  const submitUpdates = useSelector(selectArticlesMediaSubmitState);
  const { can_edit: canEdit, can_delete: canDelete, can_view: canView } = media.permissions;
  const date = new Date(media.updated * 1000);
  const title = useField('title')[0].value;

  return (
    <Grid item container xs={12} className={classes.root}>
      <MediaItemImage media={media} openMediaPreview={openMediaPreview} />
      <Grid item xs={12} className={classes.title} title={title}>
        <FormInput
          name="title"
          disabled={submitUpdates || !canEdit}
          startAdornment={<FileIcon className={clsx(classes.icon, classes.fileIcon)} />}
          classes={{ inputUnderline: classes.inputUnderline }}
          onKeyUp={keyUpHandler}
          autoComplete="off"
        />
      </Grid>
      <Grid className={classes.settingPanel} item container xs={12} alignItems="center" justify="space-between">
        <UploadProgress articleId={media.id} />
        <Tooltip classes={{tooltip: classes.tooltip}} title={date.toLocaleString()}>
          <Grid item className={'update-date'}>
            <span>{media.ref.updated_age}</span>
          </Grid>
        </Tooltip>
        <Grid item>
          {canEdit && <LockAction id={media.id} lock={media.lock_media_to_project} />}
          <AdvancedActionCell>
            {canDelete && <DeleteAction itemId={media.id} />}
            {canView && <DownloadDocumentAction document={media.ref.document} />}
          </AdvancedActionCell>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MediaPaged;
